import url from "./url";
import { $api } from "../services/api";
import { $config } from "../conf";
import Parser from "ua-parser-js";

class WeChatOAuth {
  excode = "";

  /**
   * 获取excode
   */
  getOAuth(isReset = false) {
    if (isReset || !url.GetQueryString("excode")) {
      if (Parser().browser.name === "WeChat") {
        window.location.href = `${$config.weChatOauthUrl}?weChatId=${
          $config.weChatId
        }&scope=snsapi_userinfo&return_url=${encodeURIComponent(
          location.href
        )}`;
      } else {
        window.location.href =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=APPID&redirect_uri=REDIRECT_URI&response_type=code&scope=SCOPE&state=STATE&connect_redirect=1#wechat_redirect";
      }
    } else {
      this.excode = url.GetQueryString("excode");
    }
  }

  /**
   * 获取token同时解析weChatInfo
   */
  async getToken() {
    this.getOAuth();
    let token;
    try {
      token = await $api.onMemberVerifyTokenGetbycode({
        code: this.excode,
      });
    } catch (e) {
      this.getOAuth(true);
    }
    return token ? token.content : "";
  }
}

export default new WeChatOAuth();
